export var toLowerCaseFirstChar = function toLowerCaseFirstChar(value) {
  var firstChar = value[0].toLowerCase();
  return firstChar + value.slice(1);
};